import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderSummaryForProductGroupingInput } from './GetOrderSummaryForProductGroupingInput';
import { GetOrderSummaryForProductGroupingOutput } from './GetOrderSummaryForProductGroupingOutput';

export class GetOrderSummaryForProductGroupingService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetOrderSummaryForProductGroupingInput): Promise<Result<GetOrderSummaryForProductGroupingOutput> | null> => {
    const promise = this.http.get<Result<GetOrderSummaryForProductGroupingOutput>>(`${this.baseUrlSislogApi}/v2/product-grouping/order-summary/${input.orderId}`);
    return promise;
  }
}